import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as analytics from '../utils/analytics';

/**
 * Custom hook for Google Analytics integration
 * Automatically tracks page views and provides analytics functions
 */
export const useAnalytics = () => {
  const location = useLocation();

  // Track page views on route changes (SPA navigation)
  useEffect(() => {
    const pageTitle = document.title;
    const pagePath = location.pathname + location.search;
    
    analytics.trackPageView(pageTitle, pagePath);
  }, [location]);

  return {
    // Event tracking functions
    trackEvent: analytics.trackEvent,
    trackSignup: analytics.trackSignup,
    trackLogin: analytics.trackLogin,
    trackTaskCreated: analytics.trackTaskCreated,
    trackOfferSubmitted: analytics.trackOfferSubmitted,
    trackMessageSent: analytics.trackMessageSent,
    trackSearch: analytics.trackSearch,
    trackTaskCompleted: analytics.trackTaskCompleted,
    trackError: analytics.trackError,
    setUserProperties: analytics.setUserProperties,
  };
};

export default useAnalytics;